import { render, staticRenderFns } from "./SummaryManagementDetailAccidentList.vue?vue&type=template&id=e128c820&scoped=true"
import script from "./SummaryManagementDetailAccidentList.vue?vue&type=script&lang=js"
export * from "./SummaryManagementDetailAccidentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e128c820",
  null
  
)

export default component.exports